(function () {
  'use strict';

  var MAX_IMAGES = 3;

  // Cat de clar orizontal trebuie sa fie gestul ca sa porneasca swipe-ul.
  // 1.5 = miscarea pe orizontala trebuie sa fie de 1.5x cea pe verticala.
  // Mai mare = mai tolerant la derularea paginii, mai greu de pornit swipe-ul.
  var AXIS_RATIO = 1.5;
  var START_THRESHOLD = 8;   // px parcursi inainte sa decidem axa
  var DISTANCE_RATIO = 0.18; // cat din latimea cardului = schimbare de poza
  var VELOCITY = 0.35;       // px/ms peste care conteaza viteza, nu distanta
  var EASING = 'transform .34s cubic-bezier(.22,.61,.36,1)';

  var CHEVRON_LEFT  = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function isMobileTouch() {
    return ('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
           window.matchMedia('(max-width: 749px)').matches;
  }

  function park(img) {
    var src = img.getAttribute('data-src');
    if (src) {
      img.setAttribute('data-zm-src', src);
      img.removeAttribute('data-src');
      img.classList.remove('lazyload', 'gflazyload');
    }
  }

  function wake(img) {
    var src = img.getAttribute('data-zm-src');
    if (src) {
      img.removeAttribute('data-zm-src');
      img.setAttribute('data-src', src);
      img.classList.add('lazyload');
    }
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function closestOf(el, selector) {
    if (!el || !el.closest) return null;
    try { return el.closest(selector); } catch (e) { return null; }
  }

  function disarmHover(host) {
    [host, host.parentNode, closestOf(host, 'a'), closestOf(host, '.grid-view-item'),
     closestOf(host, '.spf-product-card'), closestOf(host, '.spf-product-card__inner')
    ].forEach(function (el) {
      if (el && el.classList) {
        el.classList.add('zm-no-hover');
        el.classList.remove('hover-effect');
      }
    });
  }

  function build(host, imgs) {
    if (!host || host.getAttribute('data-zm-swipe')) return;
    host.setAttribute('data-zm-swipe', '1');

    imgs = imgs.slice(0, MAX_IMAGES);
    if (imgs.length < 2) return;

    disarmHover(host);

    var viewport = document.createElement('div');
    viewport.className = 'zm-swipe';
    var track = document.createElement('div');
    track.className = 'zm-swipe__track';
    viewport.appendChild(track);

    imgs.forEach(function (img, i) {
      if (i > 0) park(img);
      img.classList.remove('spf-product-card__image-hidden', 'spf-product-card__image-secondary');
      img.classList.add('zm-extra-image');
      img.setAttribute('draggable', 'false');
      img.style.opacity = '1';
      img.style.visibility = 'visible';
      var slide = document.createElement('div');
      slide.className = 'zm-swipe__slide';
      slide.appendChild(img);
      track.appendChild(slide);
    });

    var dots = document.createElement('div');
    dots.className = 'zm-dots';
    imgs.forEach(function (_, i) {
      var d = document.createElement('span');
      d.className = 'zm-dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });

    var woken = false;
    function wakeAll() {
      if (woken) return;
      woken = true;
      imgs.forEach(wake);
    }

    var index = 0;

    function width() {
      return viewport.clientWidth || 1;
    }

    function sync() {
      for (var k = 0; k < dots.children.length; k++) {
        dots.children[k].classList.toggle('is-active', k === index);
      }
      prev.classList.toggle('is-hidden', index <= 0);
      next.classList.toggle('is-hidden', index >= imgs.length - 1);
    }

    function goTo(i, animate) {
      index = Math.max(0, Math.min(imgs.length - 1, i));
      track.style.transition = animate ? EASING : 'none';
      track.style.transform = 'translate3d(' + (-index * width()) + 'px,0,0)';
      sync();
    }

    function makeArrow(dir) {
      var a = document.createElement('span');
      a.className = 'zm-arrow zm-arrow--' + dir;
      a.setAttribute('role', 'button');
      a.setAttribute('aria-label', dir === 'prev' ? 'Poza anterioara' : 'Poza urmatoare');
      a.innerHTML = dir === 'prev' ? CHEVRON_LEFT : CHEVRON_RIGHT;
      ['click', 'touchend'].forEach(function (evt) {
        a.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          wakeAll();
          goTo(index + (dir === 'prev' ? -1 : 1), true);
        });
      });
      return a;
    }

    var prev = makeArrow('prev');
    var next = makeArrow('next');

    host.appendChild(viewport);
    host.appendChild(prev);
    host.appendChild(next);
    host.appendChild(dots);
    sync();

    // ---- gestul, controlat de noi ----
    var startX = 0, startY = 0, startTime = 0;
    var axis = null;     // null = inca nedecis, 'x' = swipe, 'y' = derulare pagina
    var base = 0;
    var swiped = false;

    viewport.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      wakeAll();
      axis = null;
      swiped = false;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTime = Date.now();
      base = -index * width();
      track.style.transition = 'none';
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      if (!e.touches || e.touches.length !== 1 || axis === 'y') return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (axis === null) {
        if (Math.abs(dx) < START_THRESHOLD && Math.abs(dy) < START_THRESHOLD) return;
        // orice nu e clar orizontal ramane derulare verticala nativa
        axis = (Math.abs(dx) > Math.abs(dy) * AXIS_RATIO) ? 'x' : 'y';
        if (axis === 'y') return;
      }

      swiped = true;
      var w = width();
      var min = -(imgs.length - 1) * w;
      var pos = base + dx;
      if (pos > 0) pos = pos * 0.3;                 // rezistenta la capete
      if (pos < min) pos = min + (pos - min) * 0.3;
      track.style.transform = 'translate3d(' + pos + 'px,0,0)';
    }, { passive: true });

    function settle(e) {
      if (axis !== 'x') { axis = null; return; }
      var touch = e.changedTouches && e.changedTouches[0];
      var dx = touch ? touch.clientX - startX : 0;
      var velocity = dx / Math.max(1, Date.now() - startTime);
      var target = index;

      if (Math.abs(velocity) > VELOCITY) {
        target = index + (velocity < 0 ? 1 : -1);
      } else if (Math.abs(dx) > width() * DISTANCE_RATIO) {
        target = index + (dx < 0 ? 1 : -1);
      }
      goTo(target, true);
      axis = null;
    }

    viewport.addEventListener('touchend', settle, { passive: true });
    viewport.addEventListener('touchcancel', function () {
      axis = null;
      goTo(index, true);
    }, { passive: true });

    // un swipe nu trebuie sa deschida produsul
    viewport.addEventListener('click', function (e) {
      if (swiped) {
        e.preventDefault();
        e.stopPropagation();
        swiped = false;
      }
    });

    window.addEventListener('resize', function () { goTo(index, false); });
  }

  function scan() {
    if (!isMobileTouch()) return;

    toArray(document.querySelectorAll('.spf-product-card__image-wrapper')).forEach(function (host) {
      build(host, toArray(host.querySelectorAll('img')));
    });

    toArray(document.querySelectorAll('.grid-view-item__image-wrapper')).forEach(function (wrap) {
      var inner = wrap.firstElementChild;
      var host = (inner && inner.tagName === 'DIV') ? inner : wrap;
      build(host, toArray(host.querySelectorAll('img')));
    });
  }

  function boot() {
    scan();
    window.addEventListener('globoFilterRenderCompleted', function () {
      setTimeout(scan, 40);
    });
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(scan, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
